module.exports = __webpack_public_path__ + "img/logo-text.029778f5.png";